/* CUSTOMIZATIONS:
  - added related museum
*/

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import {
  PageHeader,
  InfoBox,
  PageMetadata,
  ViewBlocks,
  RelatedItems,
} from 'iovisit-theme/components/Views';

import { When, Icon } from 'iovisit-theme/components';

const messages = defineMessages({
  newsDate: {
    id: 'news_date',
    defaultMessage: 'Data',
  },
  related_items: {
    id: 'news_related_items',
    defaultMessage: 'Correlati in evidenza',
  },
});

const NewsItemView = ({ content, location }) => {
  const intl = useIntl();

  const nRelatedMuseum = content.related_museum?.length;

  return (
    <div id="page-news" className="ui container">
      <PageHeader content={{ ...content, show_share_links: true }} />

      {/* Musei correlati */}
      {nRelatedMuseum > 0 && (
        <div className="category-museum">
          <div className="icon-museum">
            <Icon prefix="fas" icon="landmark" className="icon" />
          </div>
          <div className="title-museum">
            {content.related_museum.map((item, index) => {
              return (
                <h3>
                  {item.title}
                  {index !== nRelatedMuseum - 1 && ', '}
                </h3>
              );
            })}
          </div>
        </div>
      )}

      {content.effective && (
        <InfoBox>
          <h3>{intl.formatMessage(messages.newsDate)}</h3>
          <When
            start={content.effective}
            end={content.effective}
            show_times={false}
          />
        </InfoBox>
      )}

      <ViewBlocks content={content} location={location} />

      {content.relatedItems?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.related_items)}
          items={content.relatedItems}
          background={true}
        />
      )}

      <PageMetadata content={{ ...content, show_modified: true }} />
    </div>
  );
};

export default NewsItemView;
